import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class Campaign extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedCampaign: {
      campaignName: "",
      id: "",
      campaignCompanies: [],
      onboardingTextOne: "",
      onboardingTextTwo: "",
      onboardingTextThree: "",
      campaignMaxKGCO2: 0,
      nextLeagueStart: 0,
      usersCanCreateTeams: false,
      userCreateTeamsDeadlineHours: 0,
      usersCanCompleteYesterdayActivities: false,
      maxUsersOnTeam: 0,
      minUsersOnTeam: 0,
      activityCardsDisabled: false,
      activityListDisabled: false,
      weekAmount: 0,
      campaignType: "",
      disableMissedActivitiesPopup: false,
      disableStreaks: false,
      disableQuests: false,
      campaignImage: "",
      activityPacks: { defaultPack: "" },
      extraPointsForRecommendationTaken: 0,
      extraPointsForRecommendationGiven: 0,
    },
    companies: [],
    selectedCompanies: [],
    activityPacks: [],
    notificationPacks: [],
    quizPacks: [],
    amountOfQuizzesPerDay: 0,
  };

  componentDidMount() {
    const date = new Date(this.props.campaign.nextLeagueStart * 1000);
    date.setSeconds(null);
    date.setMilliseconds(null);

    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    const formattedDate = date.toISOString().slice(0, -1);

    this.setState({
      updatedCampaign: {
        ...this.props.campaign,
        userCreateTeamsDeadlineHours: this.props.campaign
          .userCreateTeamsDeadlineHours
          ? this.props.campaign.userCreateTeamsDeadlineHours
          : 48,
        usersCanCreateTeams: this.props.campaign.usersCanCreateTeams
          ? this.props.campaign.usersCanCreateTeams
          : false,
        usersCanCompleteYesterdayActivities: this.props.campaign
          .usersCanCompleteYesterdayActivities
          ? this.props.campaign.usersCanCompleteYesterdayActivities
          : false,
        minUsersOnTeam: this.props.campaign.minUsersOnTeam
          ? this.props.campaign.minUsersOnTeam
          : 0,
        maxUsersOnTeam: this.props.campaign.maxUsersOnTeam
          ? this.props.campaign.maxUsersOnTeam
          : 0,
        activityListDisabled: this.props.campaign.activityListDisabled
          ? this.props.campaign.activityListDisabled
          : false,
        activityCardsDisabled: this.props.campaign.activityCardsDisabled
          ? this.props.campaign.activityCardsDisabled
          : false,
        streakRewardPoints: this.props.campaign.streakRewardPoints
          ? this.props.campaign.streakRewardPoints
          : 0,
        streakRewardDayFrequency: this.props.campaign.streakRewardDayFrequency
          ? this.props.campaign.streakRewardDayFrequency
          : 0,
        extraPointsForRecommendationTaken: this.props.campaign
          .extraPointsForRecommendationTaken
          ? this.props.campaign.extraPointsForRecommendationTaken
          : 0,
        extraPointsForRecommendationGiven: this.props.campaign
          .extraPointsForRecommendationGiven
          ? this.props.campaign.extraPointsForRecommendationGiven
          : 0,
        onboardingTextOne: this.props.campaign.onboarding
          ? this.props.campaign.onboarding[0]
          : "",
        onboardingTextTwo: this.props.campaign.onboarding
          ? this.props.campaign.onboarding[1]
          : "",
        onboardingTextThree: this.props.campaign.onboarding
          ? this.props.campaign.onboarding[2]
          : "",
        activityPacks: this.props.campaign.activityPacks
          ? this.props.campaign.activityPacks
          : { defaultPack: "" },
        campaignType: this.props.campaign.campaignType
          ? this.props.campaign.campaignType
          : "",
        disableMissedActivitiesPopup: this.props.campaign
          .disableMissedActivitiesPopup
          ? this.props.campaign.disableMissedActivitiesPopup
          : false,
        disableStreaks: this.props.campaign.disableStreaks
          ? this.props.campaign.disableStreaks
          : false,
        disableQuests: this.props.campaign.disableQuests
          ? this.props.campaign.disableQuests
          : false,
        campaignImage: this.props.campaign.campaignImage
          ? this.props.campaign.campaignImage
          : "",
        nextLeagueStart: formattedDate,
      },
    });
    this.setState({
      companies: this.props.companies,
      activityPacks: this.props.activityPacks,
      quizPacks: this.props.quizPacks,
      notificationPacks: this.props.notificationPacks,
    });
  }

  handleEditSave = (event, campaign, companies) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateCampaign(campaign, companies);
    this.setState({ selectedCompanies: [] });
  };

  handleCampaignEdit = (event, campaign) => {
    event.preventDefault();
    this.setState({
      selectedCompanies: this.state.companies.filter((company) =>
        campaign.campaignCompanies.includes(company.id)
      ),
    });
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      updatedCampaign: {
        ...this.state.updatedCampaign,
        [name]: value,
      },
    });
  }

  onActivityPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;
    if (select.id === `${this.state.updatedCampaign.id}activityPackDefault`) {
      this.setState({
        updatedCampaign: {
          ...this.state.updatedCampaign,
          activityPacks: {
            ...this.state.updatedCampaign.activityPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const week = parseInt(
        select.id.split(`${this.state.updatedCampaign.id}activityPack`)[1]
      );

      this.setState({
        updatedCampaign: {
          ...this.state.updatedCampaign,
          activityPacks: {
            ...this.state.updatedCampaign.activityPacks,
            [week]: value,
          },
        },
      });
    }
  };

  onQuizPackChange = (e) => {
    const select = e.target;
    const value = select.options[select.selectedIndex].value;

    if (select.id === `${this.state.updatedCampaign.id}quizPackDefault`) {
      this.setState({
        updatedCampaign: {
          ...this.state.updatedCampaign,
          quizPacks: {
            ...this.state.updatedCampaign.quizPacks,
            defaultPack: value,
          },
        },
      });
    } else {
      const week = parseInt(
        select.id.split(`${this.state.updatedCampaign.id}quizPack`)[1]
      );
      this.setState({
        updatedCampaign: {
          ...this.state.updatedCampaign,
          quizPacks: {
            ...this.state.updatedCampaign.quizPacks,
            [week]: value,
          },
        },
      });
    }
  };

  handleCampaignCopy = (event) => {
    this.setState({ isEditMode: false });
    this.props.handleAddCampaign(this.state.updatedCampaign, event, true);
  };

  render() {
    const defaultActivityPack = this.state.activityPacks.find((c) => {
      return c.id == this.props.campaign?.activityPacks?.defaultPack;
    });

    const defaultQuizPack = this.state.quizPacks.find((c) => {
      return c.id == this.props.campaign?.quizPacks?.defaultPack;
    });

    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <Fragment>
          <a
            href="/"
            onClick={(e) => {
              this.handleCampaignEdit(e, this.props.campaign);
            }}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteCampaign(this.props.campaign.id, event)
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <>
            <div className="column is-half">
              <p className="product-id">id: {this.props.campaign.id}</p>
              <p>Navn</p>
              <input
                className="input is-medium"
                type="text"
                name="campaignName"
                value={this.state.updatedCampaign.campaignName}
                onChange={this.handleInputChange}
              />
              <input
                className="is-medium"
                type="checkbox"
                name="campaignHidden"
                id={this.state.updatedCampaign.id + "campaignHidden"}
                value={this.state.updatedCampaign.campaignHidden}
                checked={this.state.updatedCampaign.campaignHidden}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedCampaign.id + "campaignHidden"}
                style={{ marginLeft: 5 }}
              >
                Skjul kampagne
              </label>
              <p>Liga start</p>
              <input
                className="input is-medium"
                type="datetime-local"
                name="nextLeagueStart"
                value={this.state.updatedCampaign.nextLeagueStart}
                onChange={this.handleInputChange}
              />
              <p>Liga længde i uger</p>
              <input
                className="input is-medium"
                type="text"
                name="weekAmount"
                value={this.state.updatedCampaign.weekAmount}
                onChange={this.handleInputChange}
              />
              <p>Tidsperiode i sekunder</p>
              <input
                className="input is-medium"
                type="text"
                name="timePeriod"
                value={this.state.updatedCampaign.timePeriod}
                onChange={this.handleInputChange}
              />
              Tidsperiode navn
              <br />
              <select
                className="select is-medium"
                type={"text"}
                name={"timePeriodName"}
                id={"timePeriodName"}
                onChange={this.handleInputChange}
                value={this.state.updatedCampaign.timePeriodName ?? "week"}
              >
                <option value={"week"}>Uge</option>
                <option value={"day"}>Dag</option>
                <option value={"round"}>Runde</option>
              </select>
              <p>Kampagnetype</p>
              <select
                className="select is-medium"
                name="campaignType"
                id={this.state.updatedCampaign.id + "campaignType"}
                value={this.state.updatedCampaign.campaignType}
                onChange={this.handleInputChange}
              >
                <option value="Standard">Standard</option>
                <option value="Mobility">Mobility</option>
              </select>
              <div className="control" style={{ marginTop: 10 }}>
                Billede:
                <select
                  name="campaignImage"
                  value={this.state.updatedCampaign.campaignImage}
                  onChange={this.handleInputChange}
                >
                  <option value=""></option>
                  {this.props.campaignImages?.map((campaignImage) => {
                    return (
                      <option key={campaignImage.Key} value={campaignImage.Key}>
                        {campaignImage.Key}
                      </option>
                    );
                  })}
                </select>
              </div>
              <>
                <div>Grundpakke</div>
                <select
                  className="select is-medium"
                  name={`${this.state.updatedCampaign.id}activityPackDefault`}
                  id={`${this.state.updatedCampaign.id}activityPackDefault`}
                  onChange={this.onActivityPackChange}
                  defaultValue={
                    this.state.updatedCampaign.activityPacks.defaultPack
                      ? this.state.updatedCampaign.activityPacks.defaultPack
                      : "def"
                  }
                >
                  <option id={"def"} value=""></option>
                  {this.props.activityPacks.map((ap) => {
                    return (
                      <option key={ap.id} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              {Array.from(
                { length: parseInt(this.state.updatedCampaign.weekAmount) },
                (_, index) => index + 1
              ).map((week) => {
                return (
                  <div key={`${this.state.updatedCampaign.id}${week}`}>
                    <div>Uge {week}</div>
                    <select
                      className="select is-medium"
                      name={`${this.state.updatedCampaign.id}activityPack${week}`}
                      id={`${this.state.updatedCampaign.id}activityPack${week}`}
                      onChange={this.onActivityPackChange}
                      defaultValue={
                        this.state.updatedCampaign.activityPacks[week]
                          ? this.state.updatedCampaign.activityPacks[week]
                          : "def"
                      }
                    >
                      <option id={"def"} value=""></option>
                      {this.props.activityPacks.map((ap) => {
                        return (
                          <option key={ap.id + week} value={ap.id}>
                            {ap.packName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}
              <>
                <div>Quiz Grundpakke</div>
                <select
                  className="select is-medium"
                  name={`${this.state.updatedCampaign.id}quizPackDefault`}
                  id={`${this.state.updatedCampaign.id}quizPackDefault`}
                  onChange={this.onQuizPackChange}
                  defaultValue={
                    this.state.updatedCampaign.quizPacks?.defaultPack
                      ? this.state.updatedCampaign.quizPacks.defaultPack
                      : "def"
                  }
                >
                  <option id={"def"} value=""></option>
                  {this.props.quizPacks.map((ap) => {
                    return (
                      <option key={ap.id} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              {Array.from(
                { length: parseInt(this.state.updatedCampaign.weekAmount) },
                (_, index) => index + 1
              ).map((week) => {
                return (
                  <div key={`${this.state.updatedCampaign.id}${week}`}>
                    <div>Uge {week}</div>
                    <select
                      className="select is-medium"
                      name={`${this.state.updatedCampaign.id}quizPack${week}`}
                      id={`${this.state.updatedCampaign.id}quizPack${week}`}
                      onChange={this.onQuizPackChange}
                      defaultValue={
                        this.state.updatedCampaign.quizPacks?.[week]
                          ? this.state.updatedCampaign.quizPacks[week]
                          : "def"
                      }
                    >
                      <option id={"def"} value=""></option>
                      {this.props.quizPacks.map((ap) => {
                        return (
                          <option key={ap.id + week} value={ap.id}>
                            {ap.packName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                );
              })}
              <p>Antal quizzer om dagen</p>
              <input
                type={"number"}
                name={"amountOfQuizzesPerDay"}
                onChange={this.handleInputChange}
                value={this.state.updatedCampaign.amountOfQuizzesPerDay}
              />
              <p>Max kg co2</p>
              <input
                className="input is-medium"
                type="text"
                name="campaignMaxKGCO2"
                value={this.state.updatedCampaign.campaignMaxKGCO2}
                onChange={this.handleInputChange}
              />
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="usersCanCreateTeams"
                id={this.state.updatedCampaign.id + "usersCanCreateTeams"}
                value={this.state.updatedCampaign.usersCanCreateTeams}
                checked={this.state.updatedCampaign.usersCanCreateTeams}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedCampaign.id + "usersCanCreateTeams"}
                style={{ marginLeft: 5 }}
              >
                Brugere kan oprette hold
              </label>
              <p>Deadline for holdoprettelse (timer)</p>
              <input
                className="input is-medium"
                type="text"
                name="userCreateTeamsDeadlineHours"
                value={this.state.updatedCampaign.userCreateTeamsDeadlineHours}
                onChange={this.handleInputChange}
              />
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="usersCanCompleteYesterdayActivities"
                id={
                  this.state.updatedCampaign.id +
                  "usersCanCompleteYesterdayActivities"
                }
                value={
                  this.state.updatedCampaign.usersCanCompleteYesterdayActivities
                }
                checked={
                  this.state.updatedCampaign.usersCanCompleteYesterdayActivities
                }
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={
                  this.state.updatedCampaign.id +
                  "usersCanCompleteYesterdayActivities"
                }
                style={{ marginLeft: 5 }}
              >
                Brugere kan indtaste for gårsdagen
              </label>
              <br />
              <p>Minimum brugere på hold</p>
              <input
                className="input is-medium"
                type="text"
                name="minUsersOnTeam"
                value={this.state.updatedCampaign.minUsersOnTeam}
                onChange={this.handleInputChange}
              />
              <br />
              <p>Max brugere på hold</p>
              <input
                className="input is-medium"
                type="text"
                name="maxUsersOnTeam"
                value={this.state.updatedCampaign.maxUsersOnTeam}
                onChange={this.handleInputChange}
              />
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="activityCardsDisabled"
                id={this.state.updatedCampaign.id + "activityCardsDisabled"}
                value={this.state.updatedCampaign.activityCardsDisabled}
                checked={this.state.updatedCampaign.activityCardsDisabled}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={
                  this.state.updatedCampaign.id + "activityCardsDisabled"
                }
                style={{ marginLeft: 5 }}
              >
                Deaktiver aktivitetskort
              </label>
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="activityListDisabled"
                id={this.state.updatedCampaign.id + "activityListDisabled"}
                value={this.state.updatedCampaign.activityListDisabled}
                checked={this.state.updatedCampaign.activityListDisabled}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedCampaign.id + "activityListDisabled"}
                style={{ marginLeft: 5 }}
              >
                Deaktiver liste af aktiviteter
              </label>
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="disableMissedActivitiesPopup"
                id={
                  this.state.updatedCampaign.id + "disableMissedActivitiesPopup"
                }
                value={this.state.updatedCampaign.disableMissedActivitiesPopup}
                checked={
                  this.state.updatedCampaign.disableMissedActivitiesPopup
                }
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={
                  this.state.updatedCampaign.id + "disableMissedActivitiesPopup"
                }
                style={{ marginLeft: 5 }}
              >
                Deaktiver popup for missede aktiviteter
              </label>
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="disableStreaks"
                id={this.state.updatedCampaign.id + "disableStreaks"}
                value={this.state.updatedCampaign.disableStreaks}
                checked={this.state.updatedCampaign.disableStreaks}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedCampaign.id + "disableStreaks"}
                style={{ marginLeft: 5 }}
              >
                Deaktiver streaks
              </label>
              <br />
              <input
                className="is-medium"
                type="checkbox"
                name="disableQuests"
                id={this.state.updatedCampaign.id + "disableQuests"}
                value={this.state.updatedCampaign.disableQuests}
                checked={this.state.updatedCampaign.disableQuests}
                onChange={this.handleInputChange}
              />
              <label
                htmlFor={this.state.updatedCampaign.id + "disableQuests"}
                style={{ marginLeft: 5 }}
              >
                Deaktiver quests
              </label>
              <br />
              <p>Streak præmiepoint</p>
              <input
                className="input is-medium"
                type="number"
                name="streakRewardPoints"
                value={this.state.updatedCampaign.streakRewardPoints}
                onChange={this.handleInputChange}
              />
              <br />
              <p>Streak dage præmiefrekvens</p>
              <input
                className="input is-medium"
                type="number"
                name="streakRewardDayFrequency"
                value={this.state.updatedCampaign.streakRewardDayFrequency}
                onChange={this.handleInputChange}
              />
              <br />
              <p>Ekstra point for taget anbefaling</p>
              <input
                className="input is-medium"
                type="number"
                name="extraPointsForRecommendationTaken"
                value={
                  this.state.updatedCampaign.extraPointsForRecommendationTaken
                }
                onChange={this.handleInputChange}
              />
              <br />
              <p>Ekstra point for givet anbefaling</p>
              <input
                className="input is-medium"
                type="number"
                name="extraPointsForRecommendationGiven"
                value={
                  this.state.updatedCampaign.extraPointsForRecommendationGiven
                }
                onChange={this.handleInputChange}
              />
              <br />
            </div>
            <div className="column is-half">
              <textarea
                name="onboardingTextOne"
                className="textarea"
                placeholder="DANSK Onboarding tekst"
                value={this.state.updatedCampaign.onboardingTextOne}
                onChange={this.handleInputChange}
              />
              <textarea
                name="onboardingTextTwo"
                className="textarea"
                placeholder="ENGELSK Onboarding tekst"
                value={this.state.updatedCampaign.onboardingTextTwo}
                onChange={this.handleInputChange}
              />
              <textarea
                name="onboardingTextThree"
                className="textarea"
                placeholder="UBRUGT Onboarding tekst"
                value={this.state.updatedCampaign.onboardingTextThree}
                onChange={this.handleInputChange}
              />
              <>
                Notifikationspakke
                <select
                  className="select is-medium"
                  name={`notificationPack`}
                  onChange={this.handleInputChange}
                  value={this.state.updatedCampaign.notificationPack}
                >
                  <option id={""} value=""></option>
                  {this.state.notificationPacks.map((ap, idx) => {
                    return (
                      <option key={ap.id + idx} value={ap.id}>
                        {ap.packName}
                      </option>
                    );
                  })}
                </select>
              </>
              <button
                type="submit"
                className="button is-info is-small mv-small"
                onClick={this.handleCampaignCopy}
              >
                Opret kopi
              </button>
              <button
                type="submit"
                className="button is-info is-small"
                onClick={(e) => {
                  this.handleEditSave(
                    e,
                    this.state.updatedCampaign,
                    this.state.selectedCompanies
                  );
                }}
              >
                Gem
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="column is-half">
              <p className="product-title">
                {this.props.campaign.campaignName}
              </p>
              <p className="product-id">
                <b>ID:</b> {this.props.campaign.id}
              </p>
              <p className="product-id">
                <b>Skjult:</b>{" "}
                {this.props.campaign.campaignHidden ? "Ja" : "Nej"}
              </p>
              <p className="product-id">
                <b>Brugere kan oprette hold: </b>
                {this.props.campaign.usersCanCreateTeams ? "Ja" : "Nej"}
              </p>
              <p className="product-id">
                <b>Deadline for holdoprettelse (timer): </b>
                {this.props.campaign.userCreateTeamsDeadlineHours ?? 0}
              </p>
              <p className="product-id">
                <b>Brugere kan indtaste for gårsdagen: </b>
                {this.props.campaign.usersCanCompleteYesterdayActivities
                  ? "Ja"
                  : "Nej"}
              </p>
              <p className="product-id">
                <b>Minimum brugere på hold: </b>
                {this.props.campaign.minUsersOnTeam ?? 0}
              </p>
              <p className="product-id">
                <b>Max brugere på hold: </b>
                {this.props.campaign.maxUsersOnTeam ?? 0}
              </p>
              <p className="product-id">
                <b>Aktivitetskort deaktiveret: </b>
                {this.props.campaign.activityCardsDisabled ? "Ja" : "Nej"}
              </p>

              <p className="product-id">
                <b>Liste af aktiviteter deaktiveret: </b>
                {this.props.campaign.activityListDisabled ? "Ja" : "Nej"}
              </p>
              <p className="product-id">
                <b>Streak præmiepoint: </b>
                {this.props.campaign.streakRewardPoints ?? 0}
              </p>
              <p className="product-id">
                <b>Streak dage præmiefrekvens: </b>
                {this.props.campaign.streakRewardDayFrequency ?? 0}
              </p>
              <p className="product-id">
                <b>Ekstra point for taget anbefaling: </b>
                {this.props.campaign.extraPointsForRecommendationTaken ?? 0}
              </p>
              <p className="product-id">
                <b>Ekstra point for givet anbefaling: </b>
                {this.props.campaign.extraPointsForRecommendationGiven ?? 0}
              </p>
              <p className="product-id">
                <b>Liga start:</b>
                {this.props.convertUnix(
                  this.props.campaign.nextLeagueStart * 1000
                )}
              </p>
              <p className="product-id">
                <b>UNIX:</b> {this.props.campaign.nextLeagueStart}
              </p>
              <p className="product-id">
                <b>Liga længde:</b> {this.props.campaign.weekAmount ?? 0}{" "}
                matchups
              </p>
              <p className="product-id">
                <b>Tidsperiode (sekunder):</b>{" "}
                {this.props.campaign.timePeriod ?? 604800} sekunder
              </p>
              <p className="product-id">
                <b>Tidsperiode navn:</b>{" "}
                {this.props.campaign.timePeriodName
                  ? this.props.campaign.timePeriodName
                  : "week"}
              </p>

              <p className="product-id">
                <b>Max kgCO2:</b> {this.props.campaign.campaignMaxKGCO2}
              </p>

              <p className="product-id">
                <b>Kampagnetype: </b>
                {this.props.campaign.campaignType || "Standard"}
              </p>
              <p className="product-id">
                <b>Deaktiver popup for missede aktiviteter: </b>
                {this.props.campaign.disableMissedActivitiesPopup
                  ? "Ja"
                  : "Nej"}
              </p>
              <p className="product-id">
                <b>Deaktiver streaks: </b>
                {this.props.campaign.disableStreaks ? "Ja" : "Nej"}
              </p>
              <p className="product-id">
                <b>Deaktiver quests: </b>
                {this.props.campaign.disableQuests ? "Ja" : "Nej"}
              </p>
              <p className="product-id">
                <b>Billede: </b>
                {this.props.campaign.campaignImage || "Ingen"}
              </p>

              <p className="product-id">
                <b>Aktivitetspakker:</b>
                <br />
              </p>
              <p key={"deffyq" + this.props.campaign.id} className="product-id">
                Faste:{" "}
                {defaultActivityPack ? defaultActivityPack?.packName : "Ingen"}
              </p>
              {this.props.campaign.activityPacks &&
                Object.keys(this.props.campaign.activityPacks).map(
                  (key, idx) => {
                    const packId = this.props.campaign.activityPacks[key];

                    if (!packId || key == "defaultPack") {
                      return;
                    }
                    const pack = this.state.activityPacks.find((c) => {
                      return c.id == packId;
                    });
                    if (!pack) {
                      return;
                    }
                    return (
                      <p
                        key={packId + this.props.campaign.id + idx}
                        className="product-id"
                      >
                        {"Runde " + key + ": " + pack?.packName}
                      </p>
                    );
                  }
                )}
              <p className="product-id">
                <b>Quizpakker:</b>
                <br />
              </p>
              <p key={"deffy" + this.props.campaign.id} className="product-id">
                Faste: {defaultQuizPack ? defaultQuizPack?.packName : "Ingen"}
              </p>
              {this.props.campaign.quizPacks &&
                Object.keys(this.props.campaign.quizPacks).map((key, idx) => {
                  const packId = this.props.campaign.quizPacks[key];

                  if (!packId || key == "defaultPack") {
                    return;
                  }
                  const pack = this.state.quizPacks.find((c) => {
                    return c.id == packId;
                  });
                  if (!pack) {
                    return;
                  }
                  return (
                    <p
                      key={packId + this.props.campaign.id + idx}
                      className="product-id"
                    >
                      {"Runde " + key + ": " + pack?.packName}
                    </p>
                  );
                })}
              <p className="product-id">
                <b>Antal quizzer om dagen: </b>
                {this.props.campaign.amountOfQuizzesPerDay}
              </p>
              <p className="product-id">
                <b>Notifikationspakke: </b>
                {this.props.campaign.notificationPack &&
                this.props.campaign.notificationPack != "N/A"
                  ? this.state.notificationPacks.find(
                      (np) => np.id == this.props.campaign.notificationPack
                    )?.packName
                  : "Ingen"}
              </p>
            </div>
            <div className="column is-half">
              <p className="product-id">
                <b>Virksomheder:</b>
                <br />
              </p>
              {this.props.campaign.campaignCompanies &&
                this.props.campaign.campaignCompanies.map((company) => {
                  return (
                    <p
                      key={this.props.campaign.id + "   " + company}
                      className="product-id"
                    >
                      {
                        this.state.companies.find((c) => {
                          return c.id == company;
                        })?.companyName
                      }
                    </p>
                  );
                })}
            </div>
          </>
        )}
      </div>
    );
  }
}
